import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const PaymentCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { clearCart } = useCart();

  useEffect(() => {
    const orderId = params.get('order_id') || params.get('merchant_order_id') || params.get('orderId');
    const status = (params.get('status') || params.get('payment_status') || '').toLowerCase();

    if (!orderId) {
      navigate('/cart');
      return;
    }

    if (status === 'success' || status === 'paid') {
      clearCart();
      navigate(`/order-success/${orderId}`);
      return;
    }

    navigate(`/payment-failed/${orderId}`);
  }, [params, navigate, clearCart]);

  return (
    <div className="min-h-screen pt-24 pb-12 bg-gradient-to-br from-amber-50 via-white to-orange-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-amber-600 border-t-transparent mx-auto mb-4"></div>
        <p className="text-amber-700">Finalizing payment status...</p>
      </div>
    </div>
  );
};

export default PaymentCallback;
